import { Field, Label, Switch } from "@headlessui/react";
import { useFormContext } from "@hudson/ui/components/ReactHookForm";
import useContent from "@lib/use_content";
import classNames from "classnames";

interface ToggleProps {
  className?: string;
  fieldName: string;
}

function CustomerRequestToggle({ className = "", fieldName }: ToggleProps): JSX.Element {
  const { data, loading, error } = useContent([
    "beCustRequestFlightTime",
    "beCustRequestPickupTime",
  ]);

  // Hook input into form
  const { setValue, watch } = useFormContext();
  const [customerRequest] = watch([fieldName]);

  return (
    <div
      className={classNames(
        className,
        "sm:border-b-2 border-[--primary-color] w-full px-2 pb-3 pt-1.5 flex sm:justify-center rounded-xl rounded-t-none ",
      )}
    >
      <Field as="div" className="flex items-center">
        <Label as="span" className="mr-3 text-xs">
          <span
            className={classNames(
              "font-bold cursor-pointer",
              customerRequest ? "text-gray-500 " : "text-[--primary-color]",
            )}
          >
            {data?.content?.beCustRequestFlightTime}
          </span>
        </Label>
        <Switch
          checked={customerRequest}
          onChange={(value) =>
            setValue(fieldName, !!value, {
              shouldDirty: true,
              shouldValidate: true,
            })
          }
          className={classNames(
            customerRequest ? "bg-[--primary-text]" : "bg-gray-200",
            "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[--primary-color] focus:ring-offset-2 ring-1 ring-gray-400",
          )}
        >
          <span
            aria-hidden="true"
            className={classNames(
              customerRequest ? "translate-x-5" : "translate-x-0",
              "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-[--primary-color] shadow ring-0 transition duration-200 ease-in-out",
            )}
          />
        </Switch>

        <Label as="span" className="ml-3 text-xs">
          <span
            className={classNames(
              "font-bold cursor-pointer",
              customerRequest ? "text-[--primary-color] " : "text-gray-500",
            )}
          >
            {data?.content?.beCustRequestPickupTime}
          </span>{" "}
        </Label>
      </Field>
    </div>
  );
}

export default CustomerRequestToggle;
